import { getStoredAccesscode } from 'lib/accesscodeStorage';

export const withAccesscodeHeader = (
  scope: string | null | undefined,
  base: HeadersInit = {}
): HeadersInit => {
  const code = getStoredAccesscode(scope);
  if (!code) return base;

  const merged: Record<string, string> = {};
  if (base instanceof Headers) {
    base.forEach((value, key) => {
      merged[key] = value;
    });
  } else if (Array.isArray(base)) {
    base.forEach(([key, value]) => {
      merged[key] = value;
    });
  } else {
    Object.assign(merged, base);
  }
  merged['X-Accesscode'] = code;
  return merged;
};
